angular.module('bmsApp.settings').controller('MMOnlineProductsCtrl', [
	'$scope',
	'$q',
	'$filter',
	'notify',
	'MMOnlineProductSvc',
	'LicenseOptionsSvc',
	'AppSettingsSvc',
	function ($scope, $q, $filter, notify, MMOnlineProductSvc, LicenseOptionsSvc, AppSettingsSvc) {

		$scope.loaded = false;

		function init() {
			let promises = {
				licenses: LicenseOptionsSvc.license().then((response) => {
					self.options.licenses = response.data.options;
					self.loading = false;
				}),
				settings: AppSettingsSvc.index().then((response) => {
					self.settingData = response.data.settings;
					self.loading = false;
				})
			};
		}

		function loadData() {
			let promises = {
				types: MMOnlineProductSvc.options().then((response) => {
					self.options.productTypes = response.data.options;
				}),
				services: MMOnlineProductSvc.index({licenseId: self.license.id}).then((response) => {
					self.servicesArray = response.data.services;
					self.customServices = response.data.custom_services;
				}),
			};

			$q.all(promises).then((response) => {
				self.services = self.servicesArray;

				angular.forEach(self.options.productTypes, (type) => {
					let existing = $filter('filter')(self.services, (item) => {
						return parseInt(item.product_type_id) === type.id;
					});
					if (existing.length === 0) {
						self.services.push({
							type: type,
							is_enabled: false,
							maids_count: 2,
						});
					}
				});

				self.loading = false;
			});
		}

		function licenseChanged() {
			loadData();
		}

		function addCustomClick() {
			self.customServices.push({
				editing: true,
				maids_count: 2,
			});
		}

		function submit() {
			let params = {
				services: self.services,
				customServices: self.customServices,
				licenseId: self.license.id,
			};
			MMOnlineProductSvc.save(params).then((response) => {
				init();
				loadData();
				notify({
					message: 'Successfully updated',
				})
			});

		}


		function saveSettings() {
			var promise;
			promise = AppSettingsSvc.update(self.settingData);

			promise.then(function (response) {
				notify({
					message: 'Settings saved'
				});
			}, function (error) {
				$scope.errors = error;
			});

		}

		let self = $scope.MMOnlineProductsCtrl = {
			loading: true,
			processing: false,
			options: {},
			custom: {},
			methods: {
				init: init,
				submit: submit,
				licenseChanged: licenseChanged,
				addCustomClick: addCustomClick,
				saveSettings: saveSettings,
			},
		};

	}]);



